module.exports = {
  language: 'Albanian',
  nationalityKay: 'sq-sq',
  personal: {
    purgePopupContent:
      'Na vjen keq, të dhënat e aplikacionit tuaj janë pastruar për shkak të politikës së sigurisë, mund të na kontaktoni nëse dëshironi të aplikoni së shpejti'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Ju lutem zgjidhni',
  multiselect: {
    deselect: 'Shtypni Enter për të larguar',
    select: 'Shtypni Enter për të zgjedhur',
    selected: 'Zgjedhur'
  },
  enter: 'Hyni',
  upload_failed: 'Ngarkimi dështoi, ju lutemi riprovoni',
  due_time: 'Koha e duhur',
  requirement: 'Kërkesa',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Login exception occurred. Are you trying to go to [ {country} - {center} ] homepage to log in? If yes, please click on 'Confirm'; if no, please click 'Cancel' to select again.",
  invalid_rediret_home_page_popup_content: 'Login exception occurred, please select the country and location to proceed.',
  'Temporarily not available': 'Nuk disponohet përkohësisht',
  'Coming soon': 'Vjen së shpejti'
};
